import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 9E908727-9325-4FC6-B8B8-C5CA52A7A827
 * name shield-half-full
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-half-full.svg
 * tags
 */
export const ShieldHalfFullIcon = createSvgIcon(<><path d="M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z" /></>, 'ShieldHalfFullIcon');
export default ShieldHalfFullIcon